var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"s-stroke","cx":"13","cy":"13.75","r":"12.2","stroke":"#507BA8","strokeWidth":"1.6","key":0}),React.createElement("path",{"className":"s-fill","d":"M18.9594 8.83146L16.8469 18.794C16.6875 19.4971 16.2719 19.6721 15.6813 19.3408L12.4625 16.969L10.9094 18.4627C10.7375 18.6346 10.5938 18.7783 10.2625 18.7783L10.4938 15.5002L16.4594 10.1096C16.7188 9.87834 16.4031 9.75021 16.0563 9.98146L8.68126 14.6252L5.50626 13.6315C4.81563 13.4158 4.80313 12.9408 5.65001 12.6096L18.0688 7.82521C18.6438 7.60959 19.1469 7.95334 18.9594 8.83146Z","fill":"#507BA8","key":1})]);
}

Icon.defaultProps = {"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
